import createTaskRoute from "./create-task-route";
import listTasksRoute from "./list-tasks-route";
import setTasksCompletionRoute from "./set-tasks-completion-route";
import addSubtaskRoute from "./add-subtask-route";
import updateTaskRoute from "./update-task-route";

export default {
  "create-task": createTaskRoute,
  "list-tasks": listTasksRoute,
  "set-tasks-completion": setTasksCompletionRoute,
  "add-subtask": addSubtaskRoute,
  "update-task": updateTaskRoute,
};
